// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { JsonRpcID } from "@lib/messaging/rpc/jsonRpc/JsonRpcID";

export type JsonRpcRequest = {
  jsonrpc: "2.0";
  method: string;
  params?: any[];
  id?: JsonRpcID;
};